import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SessionService } from "@app/shared/services/session.service";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    host: {
        class: 'app-footer'
    },
    providers: [DatePipe],
    standalone: false
})
export class FooterComponent implements OnInit {

  translateTest: string = '';

	constructor(
		private translate: TranslateService,
		public session: SessionService,
		public router: Router) {

	}

	ngOnInit(): void { }

}
